//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from 'store/constants';


//  ----------------------------------------------------------------------------
//  Actions
//  ----------------------------------------------------------------------------

//  -- Create log ----------------
export const setEbookHighlight = (highlight) => ({
  type: ActionTypes.non_native_ebook_highlight.non_native_set_ebook_highlight,
  payload:highlight,
});
export const createOrUpdateEbookHighlight = (highlight) => ({
  type: ActionTypes.non_native_ebook_highlight.non_native_update_highlight,
  payload:highlight,
});

export const clearEbookHighlighter = () => ({
    type: ActionTypes.non_native_ebook_highlight.non_native_clear_ebook_highlight,
});